import React from "react";

import { proxy } from "@/util/proxy.mjs";

export const csgoBenchmarkRefs = { VideoAd: null };

export const OVERLAY_IDS = {
  csgoBenchmark: "csgoBenchmark",
  csgoBenchmarkAd: "csgoBenchmarkAd",
};

const csgoRefs = proxy({
  MatchReplay: React.lazy(() => import("@/game-csgo/MatchReplay.jsx")),
  replayLink: (_a, _b) => null,
});

export default csgoRefs;
